import { useState } from "react";
import { useShallow } from "zustand/react/shallow";

import { api } from "@api";
import { useNotifyPromise } from "@hooks";
import {
  IAuthStepEnum,
  useAuthStore,
} from "@templates/authManagement/authStore";
import { EmailVerificationForm } from "@templates/authManagement/emailVerificationForm";

export function EmailVerificationView() {
  const notifyMutate = useNotifyPromise();
  const username = useAuthStore(
    useShallow((state) => state.forgetPasswordMeteData.userName),
  );
  const setStep = useAuthStore(useShallow((state) => state.setStep));
  const setMetaData = useAuthStore(
    useShallow((state) => state.setForgetPasswordMeteData),
  );

  const reqId = useAuthStore(
    useShallow((state) => state.forgetPasswordMeteData.reqId),
  );

  const [isWrong, setIsWrong] = useState(false);

  const { mutateAsync: sendOtp, isPending: isRequestPending } =
    api.auth.passwordReset.usePost();
  const { mutateAsync: verify, isPending: isVerifyPending } =
    api.auth.passwordReset.verify.usePost();

  const onSubmit = (code: string) => {
    notifyMutate(
      verify(
        { pathParam: undefined, code, request_id: reqId },
        {
          onSuccess: (data) => {
            setMetaData({ userName: username, reqId: data?.data?.reset_token });
            setStep(IAuthStepEnum.SET_NEW_PASSWORD);
          },
          onError: () => {
            setIsWrong(true);
          },
        },
      ),
    ).catch(() => {});
  };

  const onResendCode = async () => {
    await notifyMutate(
      sendOtp({ pathParam: undefined, phone_number: username }),
    );
  };

  return (
    <EmailVerificationForm
      onSubmit={onSubmit}
      isVerificationLoading={isRequestPending}
      isMutating={isVerifyPending}
      isWrong={isWrong}
      setIsWrong={setIsWrong}
      onResendCode={onResendCode}
    />
  );
}
